import React, { useContext, useEffect } from 'react'
import { useLocation } from 'react-router'
import { flow, toLower, startsWith } from 'lodash/fp'

import { UserContext } from './user.context'
import { useCurrentUser } from './useCurrentUser'

const LOGOUT_PATH = '/accont/logout'

const isLogoutPath: (pathname: string) => boolean = flow(
  toLower,
  startsWith(LOGOUT_PATH)
)

export const UserProvider: React.FC = ({ children }) => {
  const userContext = useCurrentUser()
  const location = useLocation()

  useEffect(() => {
    if (isLogoutPath(location.pathname)) {
      userContext.remove()
    }
  }, [location.pathname, userContext])

  useEffect(() => {
    function storageHandler(event: StorageEvent) {
      if (event.key === 'token' && !event.newValue) {
        // userContext.clearUser()
      }
    }
    window.addEventListener('storage', storageHandler)
    return () => {
      window.removeEventListener('storage', storageHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <UserContext.Provider value={userContext}>{children}</UserContext.Provider>
  )
}

export function useUser() {
  return useContext(UserContext)
}
